import {BaseWidget} from "./BaseWidget";
import {isTextToEmailLinkField, isTextToLinkField, isTextToPhoneNumberLinkField} from "../login/ClientCache";
import * as ft from "../constants/FieldType";

export class TextFieldWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        this.findElement().addClass("k-textbox");
        let linkGoTo = this.owner.rootElement().find("#" + this.elementId + "linkGoTo");
        if (linkGoTo && linkGoTo.length)
            linkGoTo.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val && !val.contains("//") && !val.toLowerCase().startsWith("tel:"))
                    val = "//" + val;
                window.open(val, "_blank");
            });
        let linkWhatsapp = this.owner.rootElement().find("#" + this.elementId + "linkwhatsapp");
        if (linkWhatsapp && linkWhatsapp.length)
            linkWhatsapp.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val)
                    window.open('https://wa.me/' + val, "_blank");
            });
        let linkCall = this.owner.rootElement().find("#" + this.elementId + "linkcall");
        if (linkCall && linkCall.length)
            linkCall.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val)
                    window.open('tel:' + val, "_blank");
            });
        let linkEmail = this.owner.rootElement().find("#" + this.elementId + "linkemail");
        if (linkEmail && linkEmail.length)
            linkEmail.on("click", (e) => {
                e.preventDefault();
                let val = this.findElement().val();
                if (val)
                    window.open('mailto:' + val, "_blank");
            });
    }

    createElement(style) {
        let that = this;
        if (isTextToPhoneNumberLinkField(that.id, that.owner.entityType) || that.fieldMetadata.fieldType == ft.PhoneNumber)
            return $(`<input class="full-width" autocomplete="off" type='text' ${style} id="${this.elementId}" nid="${this.id}"><a unselectable="on" href="#" class="k-select nama-phone-icon" id="${this.elementId}linkcall" role="button" tabindex="-1" title="${translateId('phoneCall')}"><span class="fa fa-phone"></span></a><a unselectable="on" href="#" class="k-select nama-ref-create" id="${this.elementId}linkwhatsapp" role="button" tabindex="-1" title="${translateId('whatsappMessage')}"><span class="fa fa-whatsapp"></span></a>`);
        if (isTextToEmailLinkField(that.id, that.owner.entityType) || that.fieldMetadata.fieldType == ft.Email)
            return $(`<input class="full-width" autocomplete="off" type='text' ${style} id="${this.elementId}" nid="${this.id}"><a unselectable="on" href="#" class="k-select nama-ref-create" id="${this.elementId}linkemail" role="button" tabindex="-1" title="${translateId('emailMessage')}"><span class="fa fa-envelope-o"></span></a>`);
        if (isTextToLinkField(that.id, that.owner.entityType) || that.fieldMetadata.fieldType == ft.Link)
            return $(`<input class="full-width" autocomplete="off" type='text' ${style} id="${this.elementId}" nid="${this.id}"><a unselectable="on" href="#" class="k-select nama-ref-create" id="${this.elementId}linkGoTo" role="button" tabindex="-1" title="${translateId('openLink')}"><span class="k-icon k-i-redo"></span></a>`);
        return $(`<input class="full-width" autocomplete="off"  type='text' ${style} id="${this.elementId}" nid="${this.id}">`);

    }
}